export const callReminderInclude = 'client,building,building.condominium';

export const emptyCallReminder = {
	callAt: null,
	clientId: null,
	description: '',
	sendReminderMail: false,
};
